import { ServicesContainer } from '@/services';
import { AnalyticsDataLayerEvent } from '@/services/analytics/platforms/adobe-analytics/models';
import { AppState } from '@/store';
import EventEmitter from 'events';
import { Store } from 'vuex';
import * as events from './adobe-events';

declare global {
  interface Window {
    adobeDataLayer?: {
      push(event: AnalyticsDataLayerEvent): void;
    };
  }
}

export default class AdobeAnalyticsListeners {
  static register(emitter: EventEmitter, store: Store<AppState>, services: ServicesContainer) {
    emitter.on('AddToBagEvent', e => this.send(new events.AdobeCartAddEvent(e, store, services)));
    emitter.on('RemoveFromBagEvent', e => this.send(new events.AdobeCartRemoveEvent(e, store, services)));
    emitter.on('OpenBagEvent', e => this.send(new events.AdobeCartOpenEvent(e, store, services)));
    emitter.on('ViewBagEvent', e => this.send(new events.AdobeCartViewEvent(e, store, services)));
    emitter.on('SubmitOrderEvent', e => this.send(new events.AdobeSubmitOrderEvent(e, store, services)));
    emitter.on('BagClickEvent', e => this.send(new events.AdobeBagClickEvent(e, store, services)));
    emitter.on('ProductViewEvent', e => this.send(new events.AdobeProductViewEvent(e, store, services)));
    emitter.on('HomePageLoadEvent', e => this.send(new events.AdobeHomePageLoadEvent(e, store, services)));
    emitter.on('CheckoutEvent', e => this.send(new events.AdobeCheckoutEvent(e, store, services)));
    emitter.on('LinkClickEvent', e => this.send(new events.AdobeLinkClickEvent(e, store, services)));
    emitter.on('ExternalCampaignEvent', e => this.send(new events.AdobeExternalCampaignEvent(e, store, services)));
    emitter.on('CarouselClickEvent', e => this.send(new events.AdobeCarouselClickEvent(e, store, services)));
    emitter.on('InternalCampaignEvent', e => this.send(new events.AdobeInternalCampaignEvent(e, store, services)));
    emitter.on('AccountPageLoadEvent', e => this.send(new events.AdobeAccountPageLoadEvent(e, store, services)));
    emitter.on('GroupOrderPageLoadEvent', e => this.send(new events.AdobeGroupOrderPageLoadEvent(e, store, services)));
    emitter.on('BagPageLoadEvent', e => this.send(new events.AdobeCartPageLoadEvent(e, store, services)));
    emitter.on('RestaurantLocatorClickEvent', e => this.send(new events.AdobeStoreLocatorClickEvent(e, store, services)));
    emitter.on('AccountManagementEvent', e => this.send(new events.AdobeAccountManagementEvent(e, store, services)));
    emitter.on('ErrorEvent', e => this.send(new events.AdobeErrorEvent(e, store, services)));
    emitter.on('PageNotFoundEvent', () => this.send(new events.AdobePageNotFoundEvent(store, services)));
    emitter.on('SaveDeliveryAddressEvent', (e) => this.send(new events.AdobeSaveDeliveryAddressEvent(e, store, services)));
    emitter.on('NutritionLinkClickEvent', e => this.send(new events.AdobeNutritionLinkClickEvent(e, store, services)));
    emitter.on('NutritionCalculatorPageLoadEvent', e => this.send(new events.AdobeNutritionCalculatorPageLoadEvent(e, store, services)));
    emitter.on('NutritionCalculatorAddToBagEvent', e => this.send(new events.AdobeNutritionCalculatorCartAddEvent(e, store, services)));
    emitter.on('GuacModeLinkClickEvent', e => this.send(new events.AdobeGuacModeLinkClickEvent(e, store, services)));
    emitter.on('ApiErrorEvent', e => this.send(new events.AdobeApiErrorEvent(e, store, services)));
    emitter.on('TwoStepVerificationEvent', e => this.send(new events.AdobeTwoStepVerificationEvent(e, store, services)));
    emitter.on('LoginCompleteEvent',  e => this.send(new events.AdobeLoginCompleteEvent(e, store, services)));
    emitter.on('LogoutCompleteEvent',  e => this.send(new events.AdobeLogoutCompleteEvent(e, store, services)));
    emitter.on('CreateAccountPageLoadEvent', e => this.send(new events.AdobeCreateAccountPageLoadEvent(e, store, services)));

    // Adobe Target Events //
    emitter.on('ExperienceRequestEvent', e => this.send(new events.AdobeExperienceRequestEvent(e, store, services)));
    emitter.on('PropositionDisplayEvent', e => this.send(new events.AdobeTargetPropositionDisplayEvent(e)));
  }

  private static send(event: AnalyticsDataLayerEvent) {
    try {
      window.adobeDataLayer?.push(JSON.parse(JSON.stringify(event)));
      console.log('Adobe Analytics Event Pushed To Data Layer: ', event);
    } catch (err) {
      this.handleError(err);
    }
  }

  private static handleError(err: string | null): void {
    console.log(err);
  }
}
